import { Flex } from "@otrium/core";
import { useHits } from "react-instantsearch-hooks";
import { BrandInfo } from "src/molecules/BrandInfo";
import { LoadingSpinner } from "src/atoms/LoadingSpinner";
import { Modal } from "src/atoms/Modal";
import type { AlgoliaSearchBrand } from "src/types/Algolia.d";
import type { BaseHit, Hit } from "instantsearch.js";

interface BrandInfoModal {
  open: boolean;
  loading?: boolean;
  onClose: () => void;
  pageType: "pdp" | "brandsPage";
  brand: AlgoliaSearchBrand;
}

const BrandInfoModal = ({
  open,
  loading,
  onClose,
  pageType,
}: BrandInfoModal): JSX.Element => {
  const { hits } = useHits();
  const brand = hits[0] as Hit<BaseHit & AlgoliaSearchBrand>;

  return (
    <Modal isOpen={open} onClose={onClose} overFlow="hidden">
      {loading ? (
        <Flex
          bg="White"
          height="100px"
          width="100px"
          justifyContent="center"
          alignItems="center"
        >
          <LoadingSpinner />
        </Flex>
      ) : (
        <BrandInfo brandInfo={brand} onClose={onClose} pageType={pageType} />
      )}
    </Modal>
  );
};

export default BrandInfoModal;
